import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock } from "vue";
import { ref, computed } from 'vue';
import { ElDatePicker } from 'element-plus';
import dayjs from 'dayjs';
import 'dayjs/locale/zh-cn';
export default {
  __name: 'index',
  props: {
    modelValue: {
      type: Array,
      default: () => []
    }
  },
  emits: ['update:modelValue'],
  setup(__props, {
    emit: __emit
  }) {
    dayjs.locale('zh-cn');
    const props = __props;
    const emit = __emit;
    const datePicker = ref(null);
    const shortcuts = [{
      text: '今天',
      value: () => {
        const end = dayjs().endOf('day');
        const start = dayjs().startOf('day');
        return [start, end];
      }
    }, {
      text: '昨天',
      value: () => {
        const end = dayjs().subtract(1, 'day').endOf('day');
        const start = dayjs().subtract(1, 'day').startOf('day');
        return [start, end];
      }
    }, {
      text: '本周',
      value: () => {
        const end = dayjs().endOf('day');
        const start = dayjs().startOf('week');
        return [start, end];
      }
    }, {
      text: '上周',
      value: () => {
        const end = dayjs().subtract(1, 'week').endOf('week');
        const start = dayjs().subtract(1, 'week').startOf('week');
        return [start, end];
      }
    }, {
      text: '本月',
      value: () => {
        const end = dayjs().endOf('day');
        const start = dayjs().startOf('month');
        return [start, end];
      }
    }, {
      text: '上月',
      value: () => {
        const end = dayjs().subtract(1, 'month').endOf('month');
        const start = dayjs().subtract(1, 'month').startOf('month');
        return [start, end];
      }
    }, {
      text: '本季度',
      value: () => {
        const end = dayjs().endOf('day');
        const start = dayjs().startOf('quarter');
        return [start, end];
      }
    }, {
      text: '上季度',
      value: () => {
        const end = dayjs().subtract(1, 'quarter').endOf('quarter');
        const start = dayjs().subtract(1, 'quarter').startOf('quarter');
        return [start, end];
      }
    }, {
      text: '今年',
      value: () => {
        const end = dayjs().endOf('day');
        const start = dayjs().startOf('year');
        return [start, end];
      }
    }, {
      text: '去年',
      value: () => {
        const end = dayjs().subtract(1, 'year').endOf('year');
        const start = dayjs().subtract(1, 'year').startOf('year');
        return [start, end];
      }
    }];
    const dateRange = computed({
      get: () => props.modelValue,
      set: newValue => {
        if (newValue && newValue.length === 2) {
          emit('update:modelValue', [dayjs(newValue[0]).format('YYYY-MM-DD HH:mm:ss'), dayjs(newValue[1]).format('YYYY-MM-DD HH:mm:ss')]);
        } else {
          emit('update:modelValue', []);
        }
      }
    });
    const handleChange = () => {
      if (datePicker.value) {
        datePicker.value.handleClose();
      }
    };
    return (_ctx, _cache) => {
      return _openBlock(), _createBlock(_unref(ElDatePicker), {
        modelValue: dateRange.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => dateRange.value = $event),
        type: "datetimerange",
        size: "small",
        "value-format": "YYYY-MM-DD HH:mm:ss",
        "range-separator": "至",
        "start-placeholder": "开始日期",
        "end-placeholder": "结束日期",
        shortcuts: shortcuts,
        style: {
          "height": "32px"
        },
        onChange: handleChange,
        ref_key: "datePicker",
        ref: datePicker,
        "default-time": [new Date(2000, 1, 1, 0, 0, 0), new Date(2000, 1, 1, 23, 59, 59)]
      }, null, 8, ["modelValue", "default-time"]);
    };
  }
};